"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSuiTheme = exports["default"] = void 0;
var _themes = require("baseStyles/ThemeProvider/themes");
var _react = _interopRequireWildcard(require("react"));
var _themePallete = require("./themePallete");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
;
var ThemeProviderContext = /*#__PURE__*/_react["default"].createContext({
  theme: _themes.Themes[_themes.ThemesName["default"]],
  themeName: _themes.ThemesName["default"]
});
var SuiThemeProvider = function SuiThemeProvider(_ref) {
  var children = _ref.children,
    themeName = _ref.themeName;
  var _useState = (0, _react.useState)(_themes.ThemesName["default"]),
    _useState2 = _slicedToArray(_useState, 2),
    currentTheme = _useState2[0],
    setThemeName = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    customTheme = _useState4[0],
    setCustomTheme = _useState4[1];
  (0, _react.useEffect)(function () {
    if (_themes.Themes[themeName]) {
      setCustomTheme(null);
      setThemeName(themeName);
    }
  }, [themeName]);
  var theme = (0, _react.useMemo)(function () {
    return customTheme || _themes.Themes[currentTheme];
  }, [currentTheme, customTheme]);
  var ThemeProviderState = {
    theme: theme,
    themeName: currentTheme
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ThemeProviderContext.Provider, {
    value: ThemeProviderState,
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "index.tsx"
  }, children), /*#__PURE__*/_react["default"].createElement(_themePallete.ThemePallete, {
    setCustomTheme: setCustomTheme,
    setThemeName: setThemeName,
    "data-sentry-element": "ThemePallete",
    "data-sentry-source-file": "index.tsx"
  }));
};
var useSuiTheme = function useSuiTheme() {
  var context = (0, _react.useContext)(ThemeProviderContext);
  if (!context.theme) {
    // throw Error(`Use ${useThemeProviderState.name} in ${ThemeProviderContext.displayName}`);
    console.warn("Use ".concat(useSuiTheme.name, " in ").concat(ThemeProviderContext.displayName));
  }
  return context;
};
exports.useSuiTheme = useSuiTheme;
var _default = SuiThemeProvider;
exports["default"] = _default;